import { ReactUINodes } from 'common/enums/common.js';
import { RecognisedHeaderLabels } from 'common/enums/known-data-enums.js';
import { defaultUnits, QuantitiesTypes } from 'common/enums/unit-templates.js';
import { KnowEdmTableData } from './table-enums.js';

const surveyProgramMap = new Map();

surveyProgramMap.set(KnowEdmTableData.SurveyRunAssociatedDataId, {
  key: KnowEdmTableData.SurveyRunAssociatedDataId,
  label: RecognisedHeaderLabels.SurveyRunName,
  unit: '',
  quantity: '',
  type: ReactUINodes.Select,
});

surveyProgramMap.set(KnowEdmTableData.DepthFrom, {
  key: KnowEdmTableData.DepthFrom,
  label: RecognisedHeaderLabels.DepthFrom,
  unit: defaultUnits.get(QuantitiesTypes.Depth),
  quantity: QuantitiesTypes.Depth,
});

surveyProgramMap.set(KnowEdmTableData.DepthTo, {
  key: KnowEdmTableData.DepthTo,
  label: RecognisedHeaderLabels.DepthTo,
  unit: defaultUnits.get(QuantitiesTypes.Depth),
  quantity: QuantitiesTypes.Depth,
});

export { surveyProgramMap };
